<script setup lang="ts">
import { loadNounConventions } from '~/src/data.ts';
import type { NounConventionGroup } from '~/src/nouns.ts';

const props = defineProps<{
    nounConventionGroup: NounConventionGroup;
}>();

const nounConventions = await loadNounConventions();
if (nounConventions === undefined) {
    throw new Error('no nounConventions defined');
}
const visibleNounConventions = computed(() => {
    return withKey(nounConventions.conventions).filter((nounConvention) => {
        return props.nounConventionGroup.conventions.includes(nounConvention.key);
    });
});
</script>

<template>
    <p class="h5">
        <Spelling :text="nounConventionGroup.name" />
    </p>
    <p v-if="nounConventionGroup.description" class="small my-1">
        <Icon v="info-circle" />
        <LinkedText :text="nounConventionGroup.description" />
    </p>
    <ul>
        <NounsConventionsIndexItem
            v-for="nounConvention of visibleNounConventions"
            :key="nounConvention.key"
            :noun-convention
        />
    </ul>
</template>
